import httpClient from "../httpClient";
import { API_CASE_CREATE } from "../config";

const createCase = {
  create: (data) => httpClient.post(API_CASE_CREATE, data),
};

export default createCase;
